import { PlotsService } from '@karnott/core-js';
import { API_BASE } from '../../constants';

export default new PlotsService({
  apiBase: API_BASE,
});
